"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var of_1 = require("rxjs/observable/of");
var operators_1 = require("rxjs/operators");
var fields_path_service_1 = require("../../../service/fields-path/fields-path-service");
var field_picker_direction_1 = require("../../field-picker/model/field-picker-direction");
var path_converters_1 = require("../../field-picker/path-converters");
var FieldPickerDialogComponent = /** @class */ (function () {
    function FieldPickerDialogComponent(dialogRef, fieldsPathService, data) {
        var _this = this;
        this.dialogRef = dialogRef;
        this.fieldsPathService = fieldsPathService;
        this.data = data;
        this.isInvalid = false;
        var entitySystemNames = data.entitySystemNames;
        this.path = data.path;
        this.entitySystemNames = entitySystemNames;
        if (this.path) {
            path_converters_1.convertFieldPathToFieldViews(this.path.split(':')[1], this.fieldsPathService)
                .pipe(operators_1.take(1), operators_1.catchError(function (err) {
                if (err instanceof http_1.HttpErrorResponse) {
                    _this.isInvalid = true;
                    return of_1.of([]);
                }
                throw err;
            }))
                .subscribe(function (fieldViews) {
                if (fieldViews && fieldViews.length) {
                    _this.records = fieldViews;
                }
                else {
                    _this.constructFieldViews();
                }
            });
        }
        else {
            this.constructFieldViews();
        }
    }
    FieldPickerDialogComponent.prototype.onDynamicFieldChange = function (dynamicFields) {
        this.dynamicFields = dynamicFields;
    };
    FieldPickerDialogComponent.prototype.addDynamicField = function () {
        this.dialogRef.close({
            path: this.dynamicFields[0].selectedField.targetCategory + ':' + path_converters_1.convertFieldViewsToFieldPath(this.dynamicFields),
            displayName: path_converters_1.convertFieldViewsToFieldPathDisplayName(this.dynamicFields)
        });
    };
    FieldPickerDialogComponent.prototype.constructFieldViews = function () {
        if (this.entitySystemNames && this.entitySystemNames.length) {
            var fields_1 = [];
            this.entitySystemNames.forEach(function (entitySystemName) {
                fields_1.push({
                    name: entitySystemName,
                    value: '',
                    targetCategory: entitySystemName
                });
            });
            this.records = [{
                    selectedField: fields_1[0],
                    direction: field_picker_direction_1.FieldPickerDirection.OUTGOING,
                    options: fields_1
                }];
        }
    };
    FieldPickerDialogComponent = __decorate([
        core_1.Component({
            selector: 'sis-field-picker-dialog',
            template: require('./field-picker-dialog.component.html'),
            styles: [require('./field-picker-dialog.component.css')]
        }),
        __param(2, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [material_1.MatDialogRef,
            fields_path_service_1.FieldsPathService, Object])
    ], FieldPickerDialogComponent);
    return FieldPickerDialogComponent;
}());
exports.FieldPickerDialogComponent = FieldPickerDialogComponent;
//# sourceMappingURL=field-picker-dialog.component.js.map